/* eslint-disable max-len */
import { trackLsqEvents }
  from '@programs_landing/components/undergrad/tracking/trackLsq';

const formClass = 'form-flow';
const waitlistModalId = 'waitlist-modal';
const contentClass = 'download-content';
const ctaClass = `${contentClass}__cta`;
const brochureButtonClass = 'download-brochure-button';
const curriculumButtonClass = 'download-curriculum-button';
const newsletterButtonClass = 'download-newsletter-button';
const internshipReportButtonClass = 'download-internship-button';
const activeWaitlistMode = document.querySelector(`#${waitlistModalId} .${formClass}__mode--active`);

const parentFormEl = document.querySelector(`.${formClass}__modes`);
const contentEls = document.querySelectorAll(`.${contentClass}__submission`);
const ctaLoggedInUser = document.querySelectorAll(`.${ctaClass}--can-download`);
const ctaLogOutUser = document.querySelectorAll(`.${ctaClass}--cannot-download`);
const brochureButton = document.querySelector(`.${brochureButtonClass}`);
const curriculumButton = document.querySelector(`.${curriculumButtonClass}`);
const newsletterButton = document.querySelector(`.${newsletterButtonClass}`);
const internshipReportButton = document.querySelector(`.${internshipReportButtonClass}`);

// method to show the content wherever required
function showContent() {
  ctaLogOutUser?.forEach(button => button.classList.add('hidden'));
  ctaLoggedInUser?.forEach(button => button.classList.remove('hidden'));
}

// download brochure on waitlist form submit success
function downloadBrochureSuccessFlow() {
  showContent();
  trackLsqEvents({
    activity_name: 'brochure_downloaded',
    description: 'User downloaded Brochure',
    check_existence: false,
  });
  window.open(brochureButton, '_blank');
}

// download curriculum on waitlist form submit success
function downloadCurriculumSuccessFlow() {
  showContent();
  trackLsqEvents({
    activity_name: 'brochure_downloaded',
    description: 'User downloaded Curriculum',
    check_existence: false,
  });
  window.open(curriculumButton, '_blank');
}

// download student newsletter on waitlist form submit success
function downloadNewsletterSuccessFlow() {
  showContent();
  window.open(newsletterButton, '_blank');
}

// download internship report on waitlist form submit success
function downloadInternshipReportSuccessFlow() {
  showContent();
  trackLsqEvents({
    activity_name: 'internship_report_downloaded',
    description: 'User downloaded Internship report',
    check_existence: false,
  });
  window.open(internshipReportButton, '_blank');
}

function initialize() {
  if (activeWaitlistMode && contentEls) {
    [...contentEls].forEach((contentEl) => {
      contentEl.addEventListener('click', () => {
        let successAction;
        if (contentEl.classList.contains(brochureButtonClass)) {
          successAction = 'download_brochure';
        } else if (contentEl.classList.contains(curriculumButtonClass)) {
          successAction = 'download_curriculum';
        } else if (contentEl.classList.contains(newsletterButtonClass)) {
          successAction = 'download_newsletter';
        } else if (contentEl.classList.contains(internshipReportButtonClass)) {
          successAction = 'internship_report_download';
        }
        parentFormEl?.setAttribute('data-success-action', successAction);
      });
    });
  } else {
    showContent();
  }
}

export default {
  initialize,
  showContent,
  downloadBrochureSuccessFlow,
  downloadCurriculumSuccessFlow,
  downloadNewsletterSuccessFlow,
  downloadInternshipReportSuccessFlow,
};
